import axios from 'axios'
import router from '@/routers'
export function checkErros() { 
    
    axios.interceptors.response.use( response => {
            return response
        },
        (error) => {
            if (!error.response) {
                router.push(
                    {
                        name: 'error',
                    }
                )
            }
            // switch(error.response.data.code){
            //     case "":
            //         break
            //     default:
            //         break
            // }
            return Promise.reject(error)
        }
    )

   
}
